import React, { createContext, useContext, useState } from 'react';

const PresentationContext = createContext(null);

export const PresentationProvider = ({ mode = 'default', children }) => {
  const [presentationMode, setPresentationMode] = useState(mode);

  const value = {
    mode: presentationMode,
    setMode: setPresentationMode,
    isSimpleMode: presentationMode === 'simple',
    isDefaultMode: presentationMode === 'default',
    isExpertMode: presentationMode === 'expert'
  };

  return (
    <PresentationContext.Provider value={value}>
      {children}
    </PresentationContext.Provider>
  );
};

export const usePresentation = () => {
  const context = useContext(PresentationContext);
  if (!context) {
    throw new Error('usePresentation must be used within PresentationProvider');
  }
  return context;
};

